import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Hajime',
    description: 'Hajime menjual ebook, audio dan file latihan bahasa Jepang berbahasa Indonesia untuk pemula, dari hiragana sampai persiapan JLPT N5, N4 dan JFT-Basic.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin(),
    ogImage: '/images/story/jlpt.jpg'
}

export const NAV_LINKS: NavLink[] = [
    { label: 'Tentang', href: '#story' },
    { label: 'Katalog', href: '#catalog' },
    { label: 'Cara belajar', href: '#roadmap' },
    { label: 'Tentang ujian', href: '#exams' },
    { label: 'Info terbaru', href: '#join' }
]
